<style scoped>
.noline{
  white-space:nowrap;  
}

th{
  white-space:nowrap;
}

.table-responsive { 
            height:600px;
            overflow:scroll;
}
.fijo{
    position:sticky; 
    top:0; 
    z-index:10;
    background-color: white;
}
.fijo2{
    position:sticky; 
    left:0;
    top: 0;
    /* bottom: 0;  */
    z-index:9;
    background-color:white;
    /* border-left: solid 1px #ccc;
    border-right: solid 1px #ccc; */
}
.table tbody tr .fijo2{
    background-color:white !important;

} 
</style>
<template>
    <div class="col backgroundForm">
        
        <div class="input-group col-4 offset-4">
             <select class="custom-select" id="inputGroupSelect01" v-model="captain_select_i" v-if="cDtsUser.roleAssign!=='OPERADOR'">
                 <option value="0">TODAS LAS UNIDADES</option>
                <option v-for="cp in table_dts" :value="cp.captain" :key="cp.captain">{{cp.long_detail}} {{cp.captain_name}}</option>
            </select>
            <input type="text" class="form-control-plaintext" readonly placeholder="Recipient's username" :value="cDtsUser.name_port" aria-describedby="basic-addon2" v-else>
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" @click="mPrintDetailCaptain" type="button"><font-awesome-icon icon="file-pdf" /></button>
            </div>
        </div>

        <div class="col-12 col-md-4 offset-md-8 d-print-none">
            <button class="btn btn-outline-primary"  @click="mPrintPaperCaptains">
                <font-awesome-icon icon="file-pdf" /><br>Rpte. Gral. 
            </button>
            <button class="btn btn-outline-primary" @click="mCopyToClipboard('printTable')">
                <font-awesome-icon icon="copy" /><br>copiar 
            </button>
            <button  class="btn btn-outline-dark" @click="mCallDtsCaptain"><font-awesome-icon icon="sync-alt" /><br>Actualizar</button>
        </div>       
        
        <div class="table-responsive d-print-block landscape" id="printTable">
            <h5 align="center"><b>Departamento III Operaciones</b></h5>
            <table class="table table-bordered table-hover" v-html="table_captains">
                
            </table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');


import modalLoading from '../modal/modalLoading';

export default {
    name:'report-captain',
    data(){
        return{
            captains:[],
            table_captains:'',
            uuss:[],
            engines:[],
            table_dts:[],
            table_dts_head:[],
            captain_select_i:-1
        }
    },
    mounted(){
        this.mCallDtsCaptain();
    },
    methods:{
        mCopyToClipboard(elemento) {

            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
        },
        mPrintDetailCaptain(){
            if(this.captain_select_i!==-1){
                let url_report;            
                console.log(this.captain_select_i)
                url_report=btoa(`pdfCaptainDetail/${this.captain_select_i}`);
                let route = this.$router.resolve({path: `/report/${url_report}`});
                
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.warning('Seleccione una Opcion', 'Advertencia');
            }
            
        } ,
        mPrintPaperCaptains(){
            let url_report;            
            
            url_report=btoa(`pdfMatrizCaptain`);
            let route = this.$router.resolve({path: `/report/${url_report}`});
            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            // this.$htmlToPaper('printTable');
        },
        async mCallDtsCaptain(){
            try {
                setTimeout(async ()=>{
                    let aux_captains, head_title;
                    if(this.cDtsUser.roleAssign!=='OPERADOR'){
                        aux_captains=await axios.get(`getDtsTableCaptain?api_token=${Vue.auth.getToken()}`);
                        head_title=await axios.get(`getDtsHeadTable?api_token=${Vue.auth.getToken()}`);
                    }else{
                        aux_captains=await axios.get(`getDtsTableUnidad/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
                        head_title=await axios.get(`getDtsHeadTable?api_token=${Vue.auth.getToken()}`);
                    }
                    // console.log(head_title);
                    this.table_dts=aux_captains.data;    
                    this.table_dts_head=head_title.data;
                    
                    this.mPrintTable();
                    
                }, 1000)
                
                // console.log(this.table_dts);
                // console.log(this.table_dts_head);

            } catch (error) {
                console.log(error);
            }            
        },
        mRandomColor(){
            let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
            let r = randomBetween(0, 255);
            let g = randomBetween(0, 255);
            let b = randomBetween(0, 255);
            let old_color = `rgb(${r},${g},${b}, 0.2 )`; 
            return old_color;
        },
        mPrintTable(){
            // variable que guardara los valores de la tabla
            let bAux='';
            
            // inicializamos la variable que contendra la cabecera auxiliar
            let tAux='';
            
            let tBodyAux='';

            let count_space={
                person:0,
                uuss:0,
                service:0,
                engine:0,
                comunication:0
            }

            // generamos la tabla de GGUU
            let number_row=[];
            let code=0;
            let code_old=0;
            this.table_dts.forEach(cap => {
                code=cap.distrit;
                if(code_old===0){
                    code_old=cap.distrit;
                    let aux={
                        name:cap.name_distrit,
                        code:cap.distrit,
                        row:1,
                        short_distrit:cap.short_distrit
                    }
                    number_row.push(aux);
                }else{
                    if(code===code_old){
                        // incrementamos al valor del anterior
                        let index=number_row.findIndex( cp=> cp.code===code );
                        number_row[index].row++;
                    }else{
                        // insertamos el nuevo valor y iniciamos en 1
                        code_old=cap.distrit;
                        let aux={
                            name:cap.name_distrit,
                            code:cap.distrit,
                            row:1,
                            short_distrit:cap.short_distrit
                        }
                    number_row.push(aux);
                    }
                }              

            })

            let th_gguu='';

            // aqui generamos la cabecera de la tabla

            let engine_aux='';
            let th_uuss='';
            let th_rh='';
            let service_aux='';
            let comunication_aux='';

            let total_rrhh=[];
            let total_uuss=[];
            let total_engines=[];
            // console.log(this.table_dts_head);
            
            let color_gguu=this.mRandomColor();
            let color_rrhh=this.mRandomColor();
            let color_uuss=this.mRandomColor();
            let color_engine=this.mRandomColor();
            let color_servie=this.mRandomColor();
            let color_comunication=this.mRandomColor();
            let color_coords=this.mRandomColor();


            // generamos la tabla con los datos de rrhh
            this.table_dts_head.rrhh.forEach(rh=>{
                th_rh+=`<th style="background-color:${color_rrhh}">${rh.short_detail}</th>`
                count_space.person++;

                let idxa=total_rrhh.findIndex(rah=> rah.id === rh.id);
                if(idxa === -1){
                    let aux_rrhh={
                        id:rh.id,
                        disp:0,
                        nodisp:0
                    }
                    total_rrhh.push(aux_rrhh);
                }

            })
            count_space.person+=3;
            th_rh+=`<th style="background-color:${color_rrhh}">DISP.</th><th style="background-color:${color_rrhh}">NO DISP.</th><th style="background-color:${color_rrhh}">TOTAL</th>`;
            

            
            // generamos la tabla con datos de uuss
            // console.log(this.table_dts_head.uuss);
            this.table_dts_head.uuss.forEach(us=>{
                th_uuss+=`<th style="background-color:${color_uuss}">${us.detail}</th>`;
                count_space.uuss++;

                let idxuuss=total_uuss.findIndex(usa => usa.id === us.type);
                if(idxuuss === -1){
                    let aux_uuss={
                        id:us.type,
                        disp:0,
                        nodisp:0
                    }
                    total_uuss.push(aux_uuss);
                }

            })
            count_space.uuss+=3;
            th_uuss+=`<th style="background-color:${color_uuss}">OP</th><th style="background-color:${color_uuss}">INOP</th><th style="background-color:${color_uuss}">TOTAL</th>`;


            // generamos la tabla con datos de motores
            this.table_dts_head.engine.forEach(en=>{
                engine_aux+=`<th style="background-color:${color_engine}">${en.short_detail}</th>`;
                count_space.engine++;      
                
                let idxengine=total_engines.findIndex(aen => aen.id === en.id);
                    if(idxengine === -1){
                        let aux_engine={
                            id:en.id,
                            disp:0,
                            nodisp:0
                        }
                    total_engines.push(aux_engine);
                }

            })
            count_space.engine+=3;
            engine_aux+=`<th style="background-color:${color_engine}">OP</th><th style="background-color:${color_engine}">INOP</th><th style="background-color:${color_engine}">TOTAL</th>`;

            // generamos la tabla con datos de servicios
            
            this.table_dts_head.services.forEach(ser=>{
                if(ser.item === 1){
                    service_aux+=`<th style="background-color:${color_servie}">${ser.detail}</th>`;
                    count_space.service++;
                }else{
                    comunication_aux+=`<th style="background-color:${color_comunication}">${ser.detail}</th>`;
                    count_space.comunication++;
                }
                
            })

            
            
            tAux=`<thead class="fijo" style="position:sticky; top:0; z-index:10; background-color: white;">
                        <tr>
                            <th rowspan="2" class="align-middle" style="text-align:center; background-color:${color_gguu}; " >GG.UU.</th>
                            <th rowspan="2" class="align-middle" style="text-align:center; background-color:${color_gguu}; ">UNIDAD</th>
                            <th colspan="${count_space.person}" class="align-middle" style="text-align:center; background-color:${color_rrhh}">RR.HH.</th>
                            <th colspan="${count_space.uuss}" class="align-middle" style="text-align:center; background-color:${color_uuss}">UU.SS.</th>
                            <th colspan="${count_space.engine}" class="align-middle" style="text-align:center; background-color:${color_engine}">MOTORES</th>
                            <th colspan="${count_space.service}" class="align-middle" style="text-align:center; background-color:${color_servie}">SERVICIOS</th>
                            <th colspan="${count_space.comunication}" class="align-middle" style="text-align:center; background-color:${color_comunication}">COMUNICACION</th>
                            <th colspan="2" class="align-middle" style="text-align:center; background-color:${color_coords}">COORDENADAS</th>
                        </tr>
                        <tr>                        
                            ${th_rh}
                            ${th_uuss}
                            ${engine_aux}
                            ${service_aux}
                            ${comunication_aux}
                            <th style="background-color:${color_coords}">LATITUD</th>
                            <th style="background-color:${color_coords}">LONGITUD</th>
                        </tr>
                    </thead>
                    `;


            let old_distrit_code=0;
            let old_color=null;

            this.table_dts.forEach(cap => {

                tBodyAux+='<tr>';

                let person={
                    dts:'',
                    disp:0,
                    nodisp:0,
                    total:0
                }

                let uuss={
                    dts:'',
                    op:0,
                    inop:0
                };
                let engine={
                    dts:'',
                    op:0,
                    inop:0
                };

                let services={
                    dts:''
                }

                if(cap.engines.length > 0){
                    this.table_dts_head.engine.forEach(en=>{
                        let ce=0;
                        engine.dts+='<td class="align-middle" style="text-align:center">';
                        let ctrl_not=0;

                        let op=0;
                        let nop=0;                        

                        cap.engines.forEach(eng=>{                
                            if(eng.hp===en.short_detail){
                                if(eng.state_engine==='OPERABLE'){
                                    op+=1;
                                    // engine.dts+=`<span>1 (O)</span><br>`;
                                    engine.op++;                                    
                                }else{
                                    nop+=1;
                                    // engine.dts+=`<span>1 (I)</span><br>`;
                                    engine.inop++;
                                }
                                // aqui almacenamos el total por hp
                                
                            }else{
                                ctrl_not++;
                            }
                            console.log(`llegando a una prueba`);
                        });
                        
                        if(op>0){
                            engine.dts+=`<span>${op} (O)</span><br>`;
                            let idxen=total_engines.findIndex(aen => aen.id === en.id);
                            total_engines[idxen].disp+=op;

                        }
                        if(nop>0){
                            engine.dts+=`<span>${nop} (I)</span><br>`;
                            let idxen=total_engines.findIndex(aen => aen.id === en.id);
                            total_engines[idxen].nodisp+=nop
                        }
                        if(op===0 && nop===0 && ctrl_not>0){
                            engine.dts+=`<span>--</span><br>`;
                        }
                        engine.dts+='</td>';

                    })
                    // aqui colocar los operables y no operables
                    engine.dts+=`<td class="align-middle" style="text-align:center">${engine.op}</td><td class="align-middle" style="text-align:center">${engine.inop}</td><td class="align-middle" style="text-align:center">${engine.inop + engine.op}</td>`;

                }else{
                    this.table_dts_head.engine.forEach(en=>{
                        engine.dts+=`<td class="align-middle" style="text-align:center">--</td>`;
                        let idxen=total_engines.findIndex(ena => ena.id===en.id);
                        if(idxen > -1){
                            total_engines[idxen].nodisp+=0;
                        }else{
                            let aux_rrhh={
                                id:rh.id,
                                disp:0,
                                nodisp:0
                            }
                            total_engines.push(aux_rrhh);
                        }
                    })
                    engine.dts+=`<td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td>`;
                }

                if(cap.persons.length > 0){

                    this.table_dts_head.rrhh.forEach(rh=>{
                        let ce=0;
                        person.dts+='<td class="align-middle" style="text-align:center">';
                        let ctrl_not=0;

                        let disp=0;
                        let nodisp=0;
                        

                        cap.persons.forEach(pers=>{
                            
                            if(pers.code_category===rh.id){

                                if(parseInt(pers.disponibility)===1){
                                    disp+=parseInt(pers.count);
                                    // person.dts+=`<span>${pers.count} (D)</span><br>`;
                                    person.disp+=parseInt(pers.count);
                                    
                                }
                                if(parseInt(pers.disponibility)===2){
                                    nodisp+=parseInt(pers.count);
                                    // person.dts+=`<span>${pers.count} (ND)</span><br>`;
                                    person.nodisp+=parseInt(pers.count);                                    
                                }

                            }else{
                                ctrl_not++;
                            }
                        });

                        if(disp>0){
                            person.dts+=`<span>${disp} (D)</span><br>`;
                            let idxrh=total_rrhh.findIndex(rhc => rhc.id === rh.id);
                            total_rrhh[idxrh].disp+=disp;                            
                        }
                        if(nodisp>0){
                            person.dts+=`<span>${nodisp} (ND)</span><br>`;
                            let idxrh=total_rrhh.findIndex(rhc => rhc.id === rh.id);
                            total_rrhh[idxrh].nodisp+=nodisp;
                        }
                        if(disp===0 && nodisp===0 && ctrl_not>0){
                            person.dts+=`<span>--</span>`;
                        }

                        person.dts+='</td>';
                    })
                    // aqui colocar los operables y no operables
                    person.dts+=`<td class="align-middle" style="text-align:center">${person.disp}</td><td class="align-middle" style="text-align:center">${person.nodisp}</td><td class="align-middle" style="text-align:center">${person.nodisp + person.disp}</td>`;

                }else{
                    this.table_dts_head.rrhh.forEach(rh=>{
                        person.dts+=`<td class="align-middle" style="text-align:center">--</td>`;
                        // no tiene ningun registro de las personas
                        let idxrrhh=total_rrhh.findIndex(rha => rha.id===rh.id);
                        if(idxrrhh > -1){
                            total_rrhh[idxrrhh].nodisp+=0;
                        }else{
                            let aux_rrhh={
                                id:rh.id,
                                disp:0,
                                nodisp:0
                            }
                            total_rrhh.push(aux_rrhh);
                        }
                    })
                    person.dts+=`<td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td>`;
                }
                
                
                // armamos los datos de las unidades de superficie
                if(cap.uuss.length > 0){    

                    this.table_dts_head.uuss.forEach(uus=>{
                        let ce=0;
                        uuss.dts+='<td class="align-middle" style="text-align:center">';
                        let ctrl_not=0;

                        let op=0;
                        let inop=0;                   

                        cap.uuss.forEach(us=>{
                            
                            if(us.type_ship===uus.type){

                                if(us.state_ship==='OPERABLE' || us.state_ship==='O'){
                                    op+=1;
                                    // uson.dts+=`<span>${us.count} (D)</span><br>`;
                                    uuss.op+=1;
                                }
                                if(us.state_ship==='INOPERABLE' || us.state_ship==='I'){
                                    inop+=1;
                                    // person.dts+=`<span>${pers.count} (ND)</span><br>`;
                                    uuss.inop+=1;
                                }
                            }else{
                                ctrl_not++;
                            }
                        });

                        let idxus=total_uuss.findIndex(usa => usa.id === uus.type);
                        let adisp=0;
                        let anodisp=0;
                        if(op>0){
                            uuss.dts+=`<span>${op} (O)</span><br>`;                            
                            adisp=total_uuss[idxus].disp;
                            total_uuss[idxus].disp = adisp + op;
                        }
                        if(inop>0){                            
                            uuss.dts+=`<span>${inop} (I)</span><br>`;
                            anodisp=total_uuss[idxus].nodisp;
                            // console.log(`el valor de nooperable es ${total_uuss[idxus].nodisp}`)
                            total_uuss[idxus].nodisp = anodisp + inop;
                            // console.log(`el valor de nooperable es ${total_uuss[idxus].nodisp}`)
                        }
                        if(op===0 && inop===0 && ctrl_not>0){
                            uuss.dts+=`<span>--</span>`;
                        }

                        uuss.dts+='</td>';
                    })
                    // aqui colocar los operables y no operables
                    uuss.dts+=`<td class="align-middle" style="text-align:center">${uuss.op}</td><td class="align-middle" style="text-align:center">${uuss.inop}</td><td class="align-middle" style="text-align:center">${uuss.inop + uuss.op}</td>`;

                }else{
                    this.table_dts_head.uuss.forEach(uus=>{
                        uuss.dts+=`<td class="align-middle" style="text-align:center">--</td>`;

                        let idxus=total_uuss.findIndex(usa => usa.id===uus.type);
                        if(idxus > -1){
                            total_uuss[idxus].nodisp+=0;
                        }else{
                            let aux_uuss={
                                id:uus.type,
                                disp:0,
                                nodisp:0
                            }
                            total_uuss.push(aux_uuss);
                        }
                    })
                    uuss.dts+=`<td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td><td class="align-middle" style="text-align:center">0</td>`;
                }

                // aqui armamos la tabla de servicios de la capitania
                this.table_dts_head.services.forEach(ser=>{
                    if(cap.services.length > 0 ){
                        let ser_aux={
                                detail:null
                        }
                        cap.services.forEach(serv=>{
                            
                            if(serv.service === ser.detail){
                                ser_aux.detail = serv.quality;
                            }
                        })

                        if(ser_aux.detail !== null){
                            services.dts+=`<td class="align-middle" style="text-align:center">&#10004;<br>${ser_aux.detail}</td>`;        
                        }else{
                            services.dts+=`<td class="align-middle" style="text-align:center">--</td>`;        
                        }
                    }else{
                        services.dts+=`<td class="align-middle" style="text-align:center">--</td>`;
                    }
                    
                })

                let latitud=null;
                let longitud=null;
                
                let latitud_original=cap.latitud<0 ? cap.latitud : 0;
                let longitud_original= cap.longitud<0 ? cap.longitud: 0;
                
                let latitud_aux=cap.latitud<0 ? cap.latitud * -1: 0;
                let longitud_aux=cap.longitud<0 ? cap.longitud * -1: 0;

                let entero=0;
                let minuto=0;
                let minuto_aux=0;
                let segundo=0;

                entero=Math.trunc(latitud_aux);
                minuto_aux=latitud_aux-entero;
                minuto=Math.trunc(minuto_aux*60);

                segundo=Math.trunc((minuto-minuto_aux)*60);

                latitud=`${entero}° ${minuto}' ${segundo}''`;

                entero=Math.trunc(longitud_aux);
                minuto_aux=longitud_aux-entero;
                minuto=Math.trunc(minuto_aux*60);

                segundo=Math.trunc((minuto-minuto_aux)*60);

                longitud=`${entero}° ${minuto}' ${segundo}''`;

                let coord=`<td class="noline">${latitud} <br>${latitud_original}</td><td class="noline">${longitud} <br>${longitud_original}</td>`;

                let th_gguu;

                if(old_distrit_code===0){
                    old_distrit_code=cap.distrit;

                    let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
                    let r = randomBetween(0, 255);
                    let g = randomBetween(0, 255);
                    let b = randomBetween(0, 255);

                    old_color = `rgb(${r},${g},${b}, 0.2 )`; 
                    let ix=number_row.findIndex(vl => vl.code === old_distrit_code);
                    
                    th_gguu=`<th rowspan=${number_row[ix].row} class="align-middle" style="text-align:center; background-color:${old_color};">${number_row[ix].short_distrit}</th>`;

                    tBodyAux+=`${th_gguu}<td class="align-middle fijo2" style="text-align:center; background-color:${old_color}; position:sticky; left:0; top: 0; z-index:9; background-color:white;"> ${cap.captain_name}</td>${person.dts}${uuss.dts}${engine.dts}${services.dts}${coord}</tr>`;
                }else{
                    if(old_distrit_code!==cap.distrit){
                        old_distrit_code=cap.distrit;

                        let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
                        let r = randomBetween(0, 255);
                        let g = randomBetween(0, 255);
                        let b = randomBetween(0, 255);
                        old_color = `rgb(${r},${g},${b}, 0.2 )`;

                        let ix=number_row.findIndex(vl => vl.code === old_distrit_code);
                        
                        th_gguu=`<th rowspan=${number_row[ix].row} class="align-middle" style="text-align:center; background-color:${old_color}; ">${number_row[ix].short_distrit}</th>`;

                        tBodyAux+=`${th_gguu}<td class="align-middle fijo2" style="text-align:center; background-color:${old_color}; position:sticky; left:0; top: 0; z-index:9;     background-color:white;">${cap.captain_name} </td>${person.dts}${uuss.dts}${engine.dts}${services.dts}${coord}</tr>`;
                    }else{

                        tBodyAux+=`<td class="align-middle fijo2" style="text-align:center;  background-color:${old_color}; position:sticky; left:0; top: 0; z-index:9;     background-color:white;"> ${cap.captain_name}</td>${person.dts}${uuss.dts}${engine.dts}${services.dts}${coord}</tr>`;
                    }
                }

                number_row.forEach(val=>{
                    th_gguu+=`<th rowspan=${val.row} class="align-middle" style="text-align:center">${val.name}</th>`;
                })
                
            });
            
            let aux_totales=`<th colspan="2" class="align-middle" style="text-align:center"><b>TOTALES</b></th>`;
            
            let disp_total=0;
            let nodisp_total=0;

            this.table_dts_head.rrhh.forEach(rh=>{
                // aqui generamos solo los totales por categoria
                let idxv=total_rrhh.findIndex(rha => rha.id === rh.id);
                let temp_total=total_rrhh[idxv].disp + total_rrhh[idxv].nodisp; 
                disp_total+=total_rrhh[idxv].disp;
                nodisp_total+=total_rrhh[idxv].nodisp;

                aux_totales+=`<td class="align-middle" style="text-align:center">${temp_total}</td>`;
            })
            // aqui afuerq generamos el total de todo op, inop, total

            aux_totales+=`<td class="align-middle" style="text-align:center">${disp_total}</th><td class="align-middle" style="text-align:center">${nodisp_total}</th><td class="align-middle" style="text-align:center">${disp_total + nodisp_total}</th>`;

            disp_total=0;
            nodisp_total=0;

            this.table_dts_head.uuss.forEach(us=>{
                // aqui generamos solo los totales por categoria
                let idxv=total_uuss.findIndex(rha => rha.id === us.type);
                let temp_total=total_uuss[idxv].disp + total_uuss[idxv].nodisp; 
                disp_total+=total_uuss[idxv].disp;
                nodisp_total+=total_uuss[idxv].nodisp;

                aux_totales+=`<td class="align-middle" style="text-align:center">${temp_total}</td>`;
            })
            // aqui afuerq generamos el total de todo op, inop, total

            aux_totales+=`<td class="align-middle" style="text-align:center">${disp_total}</th><td class="align-middle" style="text-align:center">${nodisp_total}</th><td class="align-middle" style="text-align:center">${disp_total + nodisp_total}</th>`;

            disp_total=0;
            nodisp_total=0;

            this.table_dts_head.engine.forEach(en=>{
                // aqui generamos solo los totales por categoria
                let idxv=total_engines.findIndex(rha => rha.id === en.id);
                let temp_total=total_engines[idxv].disp + total_engines[idxv].nodisp; 
                disp_total+=total_engines[idxv].disp;
                nodisp_total+=total_engines[idxv].nodisp;

                aux_totales+=`<td class="align-middle" style="text-align:center">${temp_total}</td>`;
            })
            // aqui afuerq generamos el total de todo op, inop, total

            aux_totales+=`<td class="align-middle" style="text-align:center">${disp_total}</th><td class="align-middle" style="text-align:center">${nodisp_total}</th><td class="align-middle" style="text-align:center">${disp_total + nodisp_total}</th>`;
            aux_totales+=`<th colspan="${(count_space.service+2)}" class="align-middle" style="text-align:center">------------------------------</th>`;

            // console.log(total_rrhh);
            // console.log(total_uuss);
            // console.log(total_engines);

            tAux+=`<tbody>
                        ${th_gguu}
                        ${tBodyAux}
                        ${aux_totales}
                    </tbody>`;

            this.table_captains=tAux;
        }

    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/uuss/reportCaptains.vue